/**
 * This will store the pod shorthand method alaises.
 *
 * @constant
 * @type {object} SHORTHAND_METHODS
 */
export const SHORTHAND_METHODS =
{
	created: 'onCreated',
	setStates: 'setupStates',
	state: 'setupStates',
	events: 'setupEvents',
	before: 'beforeSetup',
	render: 'render',
	after: 'afterSetup',
	destroy: 'beforeDestroy'
};